import { buildBodyRootMap } from "./bodyHierarchy";

export const getWorldBodyLabelForBodyUuid = (bodyUuid, bodies, worldBodies) => {
  if (!bodyUuid) return null;
  const rootMap = buildBodyRootMap(bodies || {}, worldBodies || []);
  const rootUuid = rootMap[bodyUuid] || bodyUuid;
  const entry = (worldBodies || []).find((wb) => {
    const wbUuid = typeof wb === "string" ? wb : wb.uuid;
    return wbUuid === rootUuid;
  });
  if (entry && typeof entry === "object" && entry.name) return entry.name;
  const rootBody = bodies?.[rootUuid];
  return rootBody?.name || null;
};
